import React, { useState, useEffect, useRef } from "react";

// OTP Input Component - 6 separate boxes
const OTPInput = ({ value = "", onChange, length = 6 }) => {
    const inputRefs = useRef([]);
    const [otp, setOtp] = useState(new Array(length).fill(""));

    useEffect(() => {
        if (value) {
            const valueArray = value.split("").slice(0, length);
            const newOtp = new Array(length).fill("");
            valueArray.forEach((char, idx) => {
                newOtp[idx] = char;
            });
            setOtp(newOtp);
        } else {
            setOtp(new Array(length).fill(""));
        }
    }, [value, length]);

    const handleChange = (e, index) => {
        const val = e.target.value;
        if (!/^\d*$/.test(val)) return;

        const newOtp = [...otp];

        if (val.length > 1) {
            const pastedValue = val.slice(0, length - index);
            for (let i = 0; i < pastedValue.length; i++) {
                if (index + i < length) {
                    newOtp[index + i] = pastedValue[i];
                }
            }
            setOtp(newOtp);
            onChange(newOtp.join(""));
            const nextIndex = Math.min(index + pastedValue.length, length - 1);
            inputRefs.current[nextIndex]?.focus();
            return;
        }

        newOtp[index] = val;
        setOtp(newOtp);
        onChange(newOtp.join(""));

        if (val && index < length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (!otp[index] && index > 0) {
                const newOtp = [...otp];
                newOtp[index - 1] = "";
                setOtp(newOtp);
                onChange(newOtp.join(""));
                inputRefs.current[index - 1]?.focus();
            } else {
                const newOtp = [...otp];
                newOtp[index] = "";
                setOtp(newOtp);
                onChange(newOtp.join(""));
            }
        } else if (e.key === "ArrowLeft" && index > 0) {
            inputRefs.current[index - 1]?.focus();
        } else if (e.key === "ArrowRight" && index < length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', margin: '16px 0' }}>
            {otp.map((digit, index) => (
                <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onFocus={(e) => e.target.select()}
                    className="nz-otp-box"
                />
            ))}
        </div>
    );
};

export default OTPInput;
